import { useMutation } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { PortfolioDTO } from '../../../../../RiskToleranceWorkflow/api/useSubmitAnswersMutation';
import { Detail } from '../HiddenLeversRTQ.meta';

interface Complete3dRiskToleranceWorkflowParams {
  clientId: string;
  detail: Detail;
}

const post3dRTQInputRequest = ({
  clientId,
  detail,
}: Complete3dRiskToleranceWorkflowParams): Promise<PortfolioDTO> => {
  return authFetch(
    urlWithParams('/Consumer/RiskToleranceWorkflowUpdate/InputRequest3dRtq', {
      clientId,
    }),
    { method: 'POST', ...httpBodyOptions(detail, true) },
  );
};

export const use3dRTQInputRequestMutation = () => {
  return useMutation(post3dRTQInputRequest);
};
